import { render, staticRenderFns } from "./CreateThanksBlock.vue?vue&type=template&id=51684139&scoped=true"
import script from "./CreateThanksBlock.vue?vue&type=script&lang=js"
export * from "./CreateThanksBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51684139",
  null
  
)

export default component.exports